/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min
    }

    let endTimeG

    function cutDownTime() {
        let nowTime = new Date()
        let endTime = new Date(endTimeG)

        let leftTime = endTime.getTime() - nowTime.getTime()
        if (leftTime < 0) {
            setupNewCountdown()
            leftTime = 0
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60)
        leftH = leftH >= 10 ? leftH : '0' + leftH
        leftM = leftM >= 10 ? leftM : '0' + leftM
        leftS = leftS >= 10 ? leftS : '0' + leftS

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        }
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9)
        const currentTime = new Date()
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
    }
    let intervalId

    function getCutDownTime() {
        setupNewCountdown()
        if (intervalId) clearInterval(intervalId)
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime()
            $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
            $('.sp_top_cut_down .sp_left_view .sp_minute').html(
                cutDownTimeText.minute
            )
            $('.sp_top_cut_down .sp_left_view .sp_second').html(
                cutDownTimeText.second
            )
        }, 1000)
    }

    getCutDownTime()

    let spImgList = [
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081401-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081404-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081407-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081402-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081405-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081408-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081403-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081406-pro.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/2026081409-pro.png',
        // 白
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-p1.png',
        // 灰
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-p2.png',
        // 白+灰
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/903.png?v=1785208662',
        // 黑
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250924-img3.png?v=1758696759',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/903.png?v=1759113390',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250929-pro1.png?v=1759113390',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250929-pro2.png?v=1759113390',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-p3.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-b1.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-b3.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-b2.png',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-c1.jpg',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-c2.jpg',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-c3.jpg',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-c4.jpg',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-c5.jpg',
        'https://cdn.shopify.com/s/files/1/0647/6981/8703/files/20250912-c6.jpg',
    ]
    let imgArr = [
        "https://cdn.shopify.com/s/files/1/0753/8383/2817/files/2_8111be50-c34d-415d-8a78-97fa5f1dc940.png?v=1758109159",
        "https://cdn.shopify.com/s/files/1/0753/8383/2817/files/900.png?v=1758109159"
    ]

    new Swiper('.sp-swiper1', {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,

        centeredSlides: true,
        loop: true,
    })

    function mainRender() {
        $(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)

            window.addEventListener(
                'resize',
                (function () {
                    var timer
                    return function () {
                        if (timer) clearTimeout(timer)
                        timer = setTimeout(function () {
                            $('#root').css('zoom', 'normal')
                            let scale = document.body.clientWidth / 1080
                            $('#root').css('zoom', scale)
                        }, 100)
                    }
                })()
            )
        })

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
            const config = {
                rootMargin: '0px 0px 1300px 0px',
                threshold: 0,
            }

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target
                        const dataSrc = image.getAttribute('data-src')
                        image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                        lazyLoadObserver.unobserve(image) // 停止观察该图片
                    }
                })
            },
                config)

            images.forEach(function (image) {
                lazyLoadObserver.observe(image) // 开始观察每个图片
            })
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach(subArray => {
                    subArray.forEach(url => {
                        const img = new Image()
                        img.src = url
                    })
                })
            } else {
                // 处理一维数组
                imageArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            }
        }

        lazyLoadImages()

        preloadImages(spImgList)

        // 找到绑品位置
        var linksBind = document.querySelectorAll('a[href^="#add-to-cart-form"]')
        linksBind.forEach(function (link) {
            link.addEventListener('click', function (event) {
                console.log(event)
                event.preventDefault() // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById('add-to-cart-form') // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop
                let _topHeight =
                    $('.time-part').height() +
                    $('.sp-header-top').height() +
                    $('.sp-nav').height() -
                    370
                window.scroll({
                    top:
                        offsetTop * $('div#root').css('zoom') -
                        _topHeight * $('div#root').css('zoom'),
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                }) // 方式二
            })
        })

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop
                let _topHeight =
                    $('.time-part').height() +
                    $('.sp-header-top').height() +
                    $('.sp-nav').height() +
                    50
                window.scroll({
                    top:
                        offsetTop * $('div#root').css('zoom') -
                        _topHeight * $('div#root').css('zoom') +
                        10,
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                }) // 方式二
            })
        })

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        var isAndroid = /android/i.test(userAgent)
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log('Android')
        } else if (isIOS) {
            console.log('iOS')
        } else if (isPC) {
            console.log('PC')
        } else {
            $('.sp_system').css('letter-spacing', '-4px')
        }
    }

    mainRender()

    let prods = window.product
    function getCur() {
        let color = $('#sp-color div.active').attr('data-val')
        const size = $('#sp-size div.active').attr('data-val')
        // const number = $('#sp-number div.active').attr('data-val')
        return prods.filter(
            item => item.option1 == color && item.option2 == size 
            // && item.option3 == number
        )[0]
    }
    function changePrice() {
        let num = $('#calcNumber').val()
        let price = ((getCur().price * num) / 100).toFixed(2).replace('.',',')
        let compare = ((getCur().compare_at_price * num) / 100).toFixed(2).replace('.',',')
        // let colorOptions = $("#sp-color .sp-option.active").index();
        // let perNum = 1
        // if(colorOptions == 0){
        //     perNum = 1
        // }else if(colorOptions == 1){
        //     perNum = 3
        // }else{
        //     perNum = 5
        // }
        // let perPrice = (price / perNum).toFixed(2)
        // price = (price + '').replace('.', ',')
        // compare = (compare + '').replace('.', ',')
        $('#sp_price1').html(price)
        $('#sp_price2').html(compare)
        let off_font =
            100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
        $('.product-part .price-group .sp-row span').html(off_font)
        // $(".product-part .price3 .sp-span span").html(perPrice);
    }
    $('.sp-btn-style').click(function () {
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
    })

    $('.sp-reduce').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) - 1
        if (num > 0) {
            input.value = num
        }
        changePrice()
    })
    $('.sp-add').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) + 1
        input.value = num
        changePrice()
    })
    $('.sp-option').click(function () {
        $(this).siblings().removeClass('active')
        $(this).addClass('active')

        let colorOptions = $('#sp-color .sp-option.active').index()
        // let numberIndex = $('#sp-number .sp-option.active').index()
        let numberIndex = 0
        let sizeIndex = $('#sp-size .sp-option.active').index()
        let _index = colorOptions + sizeIndex * 3;
        // $(".free-text").text(getCur().option2)
        // if (numberIndex != 0) {
        //     $(".free-img-1").show()
        //     $(".free-img-2").show()
        // } else {
        //     $(".free-img-1").hide()
        //     $(".free-img-2").hide()
        // }
        $('.product-part .sp-img-p')[0].src = spImgList[_index]
        // if (_index == 2) {
        //     $('.product-part .sp-img-p').css({
        //         marginLeft: '133px'
        //     })
        // } else {
        //     $('.product-part .sp-img-p').css({
        //         marginLeft: '250px'
        //     })
        // }
        // if (numberIndex) {
        //     $('.product-part .sp-img-p')[0].src = imgArr[_index]
        //     $('.product-part .sp-img-p').css({
        //         height: '465px',
        //         marginLeft: '202px',
        //         marginTop: '50px',
        //     })
        // } else {
        //     $('.product-part .sp-img-p')[0].src = spImgList[_index]
        //     $('.product-part .sp-img-p').css({
        //         height: '465px',
        //         marginLeft: '250px',
        //         marginTop: '50px',
        //     })
        // }

        changePrice()
    })

    $(function () {
        // 购物车加购动效
        $('.cart-btn').click(function () {
            $(this).children('img').addClass('on')
            $('.sp-header-top .sp-cart .num').show()
            setTimeout(function () {
                $('.cart-btn').children('img').removeClass('on')
            }, 500)
            $('.sp-header-top .sp-cart').addClass('on')
            setTimeout(function () {
                $('.sp-header-top .sp-cart').removeClass('on')
            }, 500)
        })

        let initNum = 0
        $('.product-part .cart-btn').click(function () {
            var data = {
                id: getCur().id,
                quantity: $('#calcNumber').val(),
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                success: function () {
                    $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                        $('#cardNum').html(result.item_count)
                        $('#cardNum').removeClass('sp-gray')
                    })
                },
                dataType: 'json',
            })

            // handleAddToCart(initNum);

            var img = $('.product-part .sp-img-p')
            // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

            var flyer = img[0].cloneNode(true)
            flyer.classList.add('sp_clone')

            $('.product-part').append(flyer)
            $('.sp_clone').css({
                width: img[0].width,
                height: img[0].height,
                background: '#e7e9ef',
                position: 'fixed',
                top: img[0].offsetTop,
                left: img.offset().left,
                'z-index': '99',
            })

            let finish = $('.sp-cart')
            $('.sp_clone').animate(
                {
                    // top: finish[0].offsetTop,
                    top: finish[0].offsetTop + $('.time-part').height() - 60,
                    left: finish[0].offsetLeft + finish.width() / 2,
                    width: 50, // 结束时的大小，根据需要调整
                    height: 50, // 结束时的大小，根据需要调整
                    opacity: 0.4,
                },
                500,
                'linear',
                function () {
                    $(this).animate(
                        {
                            width: 0,
                            height: 0,
                            opacity: 0,
                        },
                        0,
                        function () {
                            $(this).detach()
                        }
                    )
                }
            )
        })
    })

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll('span')
        const paragraph = gradually.querySelector('.sp-sub-title')

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`
                            span.style.animationDelay = `${index * 0.1}s`

                            const i = span.querySelector('i')
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`
                                i.style.animationDelay = `${index * 0.1}s`
                            }
                        })

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
                            paragraph.style.animationDelay = `${totalDelay}s`
                        }

                        observer.unobserve(gradually)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observer.observe(gradually)
    }

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName('sp-fade-box')
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll('.sp-ani')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`
                        })

                        observerAni.unobserve(gradually2)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually2)
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`
                            span.style.animationDelay = `${index * 0.3 + 1}s`
                        })

                        observerAni.unobserve(gradually3)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually3)
    }

    // 环形旋转木马
    // var slideW = 360; //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
    // var radius = (slideW * 0.5) / Math.sin(Math.PI / 16); //半径。圆心并不是视点中心，视点在1200px
    var slideW = 360 //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
    var radius = (slideW * 0.5) / Math.sin(Math.PI / 16) //半径。圆心并不是视点中心，视点在1200px

    carouselSwiper = new Swiper('#carousel .swiper', {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: true,
        loopedSlides: 3,
        grabCursor: true,
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
        freeMode: true,
        speed: 5000, //匀速时间
        on: {
            progress: function (swiper, progress) {
                for (i = 0; i < this.slides.length; i++) {
                    var slide = this.slides.eq(i)
                    var slideProgress = this.slides[i].progress
                    const translateX =
                        (slideProgress + 1.5) *
                        (slideW / 3 -
                            (Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) *
                                slideW *
                                1.1) /
                            3) +
                        'px' //调整图片间距，根据图片宽度改变数值实现自适应
                    const rotateY = (slideProgress + 1.5) * 22.5 //图片角度
                    const translateZ =
                        radius -
                        Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) * radius -
                        150 +
                        'px' //调整图片远近，刚好4个在画框内
                    slide.transform(
                        'translateX(' +
                        translateX +
                        ') translateZ(' +
                        translateZ +
                        ') rotateY(' +
                        rotateY +
                        'deg)'
                    )
                }
            },
            setTransition: function (swiper, transition) {
                for (var i = 0; i < this.slides.length; i++) {
                    var slide = this.slides.eq(i)
                    slide.transition(transition)
                }
            },
        },
    })
})
